import React,{ useState, useEffect } from 'react';
import Spinner from 'react-bootstrap/Spinner';

export const CurrentHorse = (props) => {
  const [data, setdata] = useState([]);
  const [loaded, setloaded] = useState(false);

  useEffect(() => {
    if(props.data.length !== 0) {
      setdata(props.data);
      setloaded(true);
    }
  }, [props]);

  const gender = ["Hingst", "Sto"];

  function info() {
    return(
      <>
          <h2 className='toppadding2'>#{data.current.hipnr} {data.current.horsename}</h2>
          <div className='break'></div>
          <ul className='bottompadding2'>
            <li>
              <span className='inline-block' style={{width: "300px"}}><b>Kön:</b></span> 
              <span className='inline-block' style={{width: "500px"}}>{data.current.gender}</span></li>
            <li>
              <span className='inline-block' style={{width: "300px"}}><b>Far:</b></span> 
              <span className='inline-block' style={{width: "500px"}}>{data.current.father}</span>
            </li>
            <li>
              <span className='inline-block' style={{width: "300px"}}><b>Mor:</b></span> 
              <span className='inline-block' style={{width: "500px"}}>{data.current.mother}</span>
            </li>
            
            <li>
              <span className='inline-block' style={{width: "300px"}}><b>Morfar:</b></span> 
              <span className='inline-block' style={{width: "500px"}}>{data.current.grandpa}</span>
            </li>
          </ul>
      </>
    )
  }

  let content = loaded
    ? info()
    : <Spinner/>;

    return(
      <>
        {content}
      </>
    );
}